// API Configuration
export const API_ENDPOINTS = {
  RATES: '/api/rates',
  NEWS: '/api/news',
  MARKET_DATA: '/api/market-data',
  OPENAI_API: 'https://api.openai.com/v1',
};

// API Keys
export const API_KEYS = {
  OPENAI_API_KEY: import.meta.env.VITE_OPENAI_API_KEY,
};